module.exports = __webpack_public_path__ + "dcfe9ec77dbb173a19c4888319cde28a.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-80@2x.png
// module id = 538
// module chunks = 0